export const generateServices = (request, map) => {
  const id = request.serviceId ?? 0;

  const entity = map.get(id) || {
    name: request.service ?? 'Не указано',
    value: 0,
    id,
    parentId: request.parentServiceId,
  };

  entity.value += 1;
  map.set(id, entity);
};
